import { environment } from '../../environments/environment';

/** Base domain → location map (development, Amplify default URLs) */
const BASE_DOMAIN_MAP: Record<string, string> = {
  'localhost': 'default',
  '127.0.0.1': 'default',
};

/** Domains that always resolve to default (Amplify Hosting, preview branches, etc.) */
const AMPLIFY_HOSTING_SUFFIX = '.amplifyapp.com';

/**
 * Domain → location mapping for multi-site support.
 * Merges base defaults with environment.domainToLocationMap (from environment.ts).
 * Production builds use environment.prod.ts with production domains.
 */
export const DOMAIN_TO_LOCATION_MAP: Record<string, string> = {
  ...BASE_DOMAIN_MAP,
  ...(typeof (environment as any).domainToLocationMap === 'object'
    ? (environment as any).domainToLocationMap
    : {
        'aruba-adventures.com': 'aruba',
        'www.aruba-adventures.com': 'aruba',
        'bonaire-excursions.com': 'bonaire',
        'www.bonaire-excursions.com': 'bonaire',
        'curacao-adventures.com': 'curacao',
        'www.curacao-adventures.com': 'curacao',
      }),
};

/** Location used when hostname is not in the map (e.g. new domains, staging) */
export const DEFAULT_FALLBACK_LOCATION = 'default';

/** Resolve hostname to location. Handles Amplify Hosting URLs (*.amplifyapp.com) as default. */
export function resolveLocationForHostname(hostname: string): string {
  const lower = hostname.toLowerCase();
  if (DOMAIN_TO_LOCATION_MAP[lower]) {
    return DOMAIN_TO_LOCATION_MAP[lower];
  }
  if (lower.endsWith(AMPLIFY_HOSTING_SUFFIX)) {
    return DEFAULT_FALLBACK_LOCATION;
  }
  return DEFAULT_FALLBACK_LOCATION;
}
